import { FC, useMemo, useCallback } from 'react'
import { accountActionsMap, isProviderAccount } from 'helpers/linkageHelpers'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { startLinkageSessionActionCreator } from 'actions/linkageActions'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountActionContinueHandlerProps = {
  accountInfo: MixedAccountsTableItem
}

export const AccountActionContinueHandler: FC<AccountActionContinueHandlerProps> = (props) => {
  const { accountInfo, children } = props
  const { providerAccountState, providerAccount } = accountInfo
  const { actions } = providerAccountState

  const dispatch = useStoreDispatch()

  const handleClick = useCallback(() => {
    if (isProviderAccount(providerAccount)) {
      dispatch(startLinkageSessionActionCreator.request(providerAccount))
    }
  }, [dispatch, providerAccount])

  const isExist = useMemo(() => {
    const actionsMap = accountActionsMap(actions)
    return !!actionsMap.continue
  }, [actions])

  if (!isExist) {
    return null
  }

  return (
    <div onClick={ handleClick }>
      { children }
    </div>
  )
}
